// extracted by mini-css-extract-plugin
export default {"container":"tile_container__vzghN","tile":"tile_tile__U00-K","text":"tile_text__Bi8WA"};